"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { useEditorState } from "@tiptap/react";
import { useRef } from "react";
import { LuBaseline } from "react-icons/lu";
import { Button } from "@/components/ui";
export function TextColorButton() {
  const $ = _c(17);
  const {
    editor
  } = useEmailComposer();
  const colorInputRef = useRef(null);
  let t0;
  if ($[0] !== editor) {
    t0 = {
      editor,
      selector: _temp
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentColor = useEditorState(t0);
  const hasCustomColor = currentColor && currentColor !== "#000000" && currentColor !== null;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => colorInputRef.current?.click();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== currentColor || $[4] !== hasCustomColor) {
    t2 = hasCustomColor ? {
      color: currentColor
    } : undefined;
    $[3] = currentColor;
    $[4] = hasCustomColor;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LuBaseline size={16} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <Button type="button" variant="ghost" size="icon-sm" onClick={t1} tooltip="Text color"><span style={t2}>{t3}</span></Button>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = currentColor ?? "#000000";
  let t6;
  if ($[9] !== editor) {
    t6 = e => {
      if (!editor) {
        return;
      }
      editor.chain().focus().setColor(e.target.value).run();
      trackEmailComposerAction("text_color_changed", "toolbar");
    };
    $[9] = editor;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <input ref={colorInputRef} type="color" value={t5} onChange={t6} className="absolute inset-0 h-full w-full cursor-pointer opacity-0" title="Text color" />;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className="relative">{t4}{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
function _temp(ctx) {
  return ctx.editor?.getAttributes("textStyle").color as string ?? "#000000";
}